import React, { useEffect, useState } from "react";
import Header from "./Header";
import Hero from "./Hero";
import About from "./About";
import IrrrigationInformation from "./IrrrigationInformation";
import Footer from "./Footer";
import LandingSchemes from "./schemes/LandingSchemes";
import LandingProjects from "./projects/LandingProjects";
import MapAnalysis from "./map-analysis/MapAnalysis";
import Reports from "./reports/Reports";
import InvestmentCalculator from "./investment-calculator/InvestmentCalculator";

function Landing() {
  const [active, setActive] = useState("home");

  useEffect(() => {
    window?.scrollTo({ top: 0, behavior: "smooth" });
  }, [active]);
  return (
    <>
      <Header active={active} setActive={setActive} />
      {active === "landing-schemes" ? (
        <>
          <LandingSchemes />
          <Footer />
        </>
      ) : active === "projects" ? (
        <>
          <LandingProjects />
          <Footer />
        </>
      ) : active === "map" ? (
        <>
          <MapAnalysis />
          <Footer />
        </>
      ) : active === "reports" ? (
        <>
          <Reports />
          <Footer />
        </>
      ) : active === "InvestmentCalculator" ? (
        <>
          <InvestmentCalculator />
          <Footer />
        </>
      ) : (
        <>
          <Hero />
          <About />
          <IrrrigationInformation />
          <Footer />
        </>
      )}
    </>
  );
}

export default Landing;
